import React, { Component } from "react";
import {
  Paper,
  MenuList,
  Accordion,
  AccordionSummary,
  Button,
} from "@material-ui/core";
import "react-h5-audio-player/lib/styles.css";
import Typography from "@material-ui/core/Typography";
import packageJson from "../../../package.json";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./Navigation.css";
import PermittedContent from "_module/component/permitted-content/PermittedContent";
// import { _smSysAdmin, _manageUsers } from "../../_module/definition/SmSysAdmin";
// import { _smContentAdmin } from "../../_module/definition/SmContentAdmin";
// import { _mlLibraries } from "../../_module/definition/MlLibraries";
// import { _mlAdmin } from "../../_module/definition/MlAdmin.js";
// import { _mlCanManagePlaylists, _mlPlaylists } from "../../_module/definition/MlPlaylists.js";
// import { _smLog } from "../../_module/definition/SmLog.js";
// import { _smReports } from "../../_module/definition/SmReports.js";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { GrDocumentText } from "react-icons/gr";
import {
  FaUser,
  FaUpload,
  FaUserEdit,
  FaSearch,
  FaUsersCog,
  FaUserCog,
  FaWpforms,
  FaRegCopyright,
  FaSatelliteDish,
} from "react-icons/fa";
import { MdQueueMusic } from "react-icons/md";
import { withRouter } from "react-router";
// import { _uploads } from "../../_module/definition/Uploads";
import { _PermittedContent } from "./../../_module/utils/PermittedContent";
import { toggleNav } from "../../redux/actions/UserActions";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { defaultGroups } from "../../redux/Types";
//import Acceptable_Use_Policy from "../../public/Acceptable_Use_Policy.pdf";
import store from "redux/Store";

const MlLicensingAdminNavigation = React.lazy(() =>
  import("../../modules/ml-licensing-admin/Navigation")
);

const MlAdminNavigation = React.lazy(() =>
  import("../../modules/ml-admin/Navigation")
);

const MLContentAdminNavigation = React.lazy(() =>
  import("../../modules/ml-content-admin/Navigation")
);

const MlTrackNavigation = React.lazy(() =>
  import("../../modules/ml-music-search/Navigation")
);

const PlaylistsNavigation = React.lazy(() =>
  import("../../modules/ml-playlist/Navigation")
);

const SMContentAdminNavigation = React.lazy(() =>
  import("../../modules/sm-admin/Navigation")
);

const SMLogNavigation = React.lazy(() =>
  import("../../modules/sm-log/Navigation")
);

const SMReportsNavigation = React.lazy(() =>
  import("../../modules/sm-reports/Navigation")
);

const MlLicensingNavigation = React.lazy(() =>
  import("../../modules/ml-licensing/Navigation")
);

const TrackUploadNavigation = React.lazy(() =>
  import("../../modules/ml-track-upload/Navigation")
);

const PlayOutNavigation = React.lazy(() =>
  import("../../modules/ml-playout/Navigation")
);

const SMAdminNavigation = React.lazy(() =>
  import("../../modules/sm-admin/Navigation")
);

const SMSYSAdminNavigation = React.lazy(() =>
  import("../../modules/sm-sys-admin/Navigation")
);

const MLAdminNavigation = React.lazy(() =>
  import("../../modules/ml-content-admin/Navigation")
);

const ContentTrackerNavigation = React.lazy(() =>
  import("../../modules/ml-content-tracker/Navigation")
);

const MlAllNewsNavigation = React.lazy(() =>
  import("../../modules/ml-all-news/Navigation")
);

const Navigation = (props) => {
  const {
    classes,
    user,
    user: { navExapnded },
    toggleNav,
    location: { search, pathname },
    allNews: {
      latestTotalItems, 
      latestLoading
    }
    // orgRuntime: {
    //   runtime: {
    //     _mlAdmin: _mlAdmin,
    //     _playouts: _playouts
    //   }
    // } 
  } = props;


  let currentRouteLocation = props.location.pathname;

  const getCurrentRoute = () => {
    let cLocation = currentRouteLocation.toLowerCase().split("/");
    let palylistRoute = ["playlist", "pl-inbox", "pl-outbox", "pl-promo"];
    if (cLocation.length === 2 && palylistRoute.indexOf(cLocation[1]) !== -1) {
      return "playlist";
    } else if (cLocation.length > 2) {
      return cLocation[1];
    } else {
      return false;
    }
  };

  props.history.listen((location, action) => {
    currentRouteLocation = location.pathname;
    setExpanded(getCurrentRoute);
  });

  const [expanded, setExpanded] = React.useState(getCurrentRoute);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);

    if (isExpanded) {
      props.history.push("/" + panel);
    }
  };

  const handleToggle = () => (event) => {
    toggleNav(navExapnded);
  };

  var playlistPermitted = _PermittedContent([props.orgRuntime.runtime._mlPlaylists]) ? true : false;
  var playlistManagePermitted = _PermittedContent([props.orgRuntime.runtime._mlPlaylists,props.orgRuntime.runtime._mlCanManagePlaylists]) ? true : false;
  var trackPermitted = _PermittedContent([props.orgRuntime.runtime._mlLibraries]) ? true : false;
  var albumPermitted = _PermittedContent([props.orgRuntime.runtime._mlAlbums]) ? true : false;

  const isContentTeam = () => {
    let isInContentTeam = false;
    if (user?.credentials?.orgs?.length > 0) {
      user.credentials.orgs.map((org) => {
        if (org.id === user?.credentials?.orgID && Array.isArray(org.groups)) {
          isInContentTeam =
            org.groups.findIndex((v) => v === defaultGroups.CONTENT_GROUP) !==
            -1;
        }
      });
    }
    return isInContentTeam;
  };

  const isSysAdmin = () => {
    const {
      orgRuntime: {
        runtime: {
          _mlAdmin: _mlAdmin,
          _playouts: _playouts, 
          _smSysAdmin, 
          _manageUsers, 
        }
      } 
    } = store.getState();
    let canSysAdminManageUsers = _PermittedContent([_smSysAdmin, _manageUsers]);
    let isMlAdmin = _PermittedContent([_mlAdmin]);
    if (canSysAdminManageUsers) {
      return true;
    } else if (isMlAdmin) {
      return true;
    } else {
      return false;
    }
  };

  const {
    orgRuntime: {
      runtime: {
        _mlAdmin: _mlAdmin,
        _playouts: _playouts,
        _contentRequest,
        _mlContentAdmin,
        _mlLicensing,
        _mlLicensingAdmin, 
        _uploads, 
        _smLog, 
        _smReports, 
        _smSysAdmin, 
        _manageUsers, 
        _smContentAdmin
      }
    } 
  } = store.getState();

  return (
    <Translation>
      {(t, { i18n }) =>
        (search && search.includes("?uploadTracks") || pathname && pathname.includes("/downloader/")) ? null : (
          <Paper className={classes.root}>
            {/* search */}
            <Button
              className={
                navExapnded
                  ? classes.collapsibleButtonLeft
                  : classes.expandableButtonLeft
              }
              aria-label={
                navExapnded
                  ? "Left Collapsible Button"
                  : "Left Expandable Button"
              }
              onClick={handleToggle()}
            >
              {navExapnded ? <FaAngleRight /> : <FaAngleLeft />}
            </Button>

            {trackPermitted || albumPermitted ? (
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "search"}
                onChange={handleChange("search")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="musicsearchcontent"
                  id="musicsearch"
                >
                  <FaSearch
                    title="Search"
                    fontSize="small"
                    className={classes.newIcons}
                  />
                  <Typography className={classes.navigationTitle}>
                    Search
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="musicsearch"
                  id="musicsearchcontent"
                >
                  <MenuList className={classes.navList}>
                    <MlTrackNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            ) : null}

            {/* Playlists */}
            {/* <PermittedContent modulePath={_mlPlaylists}> */}
            <Accordion
              className={classes.navigationAccordianTitle}
              expanded={expanded === "playlist" || expanded === "pl-inbox"}
              onChange={handleChange(
                playlistPermitted ? (playlistManagePermitted ? "playlist" : "pl-inbox") : "pl-promo"
              )}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="playlistcontent"
                id="playlist"
              >
                <MdQueueMusic
                  title="Playlists"
                  style={{ fontSize: "1.5em" }}
                  className={classes.newIcons}
                />
                <Typography className={classes.navigationTitle}>
                  Playlists
                </Typography>
              </AccordionSummary>
              <AccordionDetails aria-labelledby="playlist" id="playlistcontent">
                <MenuList className={classes.navList}>
                  <PlaylistsNavigation classes={classes} />
                </MenuList>
              </AccordionDetails>
            </Accordion>
            {/* </PermittedContent> */}

            {/* Clearance */}
            <PermittedContent modulePath={_mlLicensing}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "mllicensing"}
                onChange={handleChange("mllicensing")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="clearancecontent"
                  id="clearance"
                >
                  <FaWpforms
                    title="Clearance"
                    fontSize="small"
                    className={classes.newIcons}
                  />
                  <Typography className={classes.navigationTitle}>
                    Clearance
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="clearance"
                  id="clearancecontent"
                >
                  <MenuList className={classes.navList}>
                    <MlLicensingNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            {/* All News */}
            <MenuList className={classes.navList}>
              <MlAllNewsNavigation classes={classes} latestLoading={latestLoading ?? false} latestTotalItems={latestTotalItems ?? ""} />
            </MenuList>

            {/* Licensing */}
            <PermittedContent modulePath={_mlLicensingAdmin}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "mllicensingadmin"}
                onChange={handleChange("mllicensingadmin")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="mlliadmincontent"
                  id="mlliadmin"
                >
                  <FaRegCopyright
                    title="Licensing"
                    fontSize="small"
                    className={classes.newIcons}
                  />
                  <Typography className={classes.navigationTitle}>
                    Licensing
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="clearance"
                  id="mlliadmincontent"
                >
                  <MenuList className={classes.navList}>
                    <MlLicensingAdminNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            {/* Content Admin */}
            <PermittedContent modulePath={_mlContentAdmin}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "ml-admin"}
                onChange={handleChange("ml-admin")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="mladmincontent"
                  id="ml-admin"
                >
                  <FaUserEdit
                    title="Content Admin"
                    fontSize="small"
                    className={classes.newIcons}
                  />

                  <Typography className={classes.navigationTitle}>
                    Content Admin
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="ml-admin"
                  id="mladmincontent"
                >
                  <MenuList className={classes.navList}>
                    <MLAdminNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            {/* Content Tracker */}
            <PermittedContent modulePath={_contentRequest}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "content-tracker"}
                onChange={handleChange("content-tracker")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="trackercontent"
                  id="content-tracker"
                >
                  <GrDocumentText
                    title="Content Tracker"
                    fontSize="small"
                    className={classes.newIcons}
                  />

                  <Typography className={classes.navigationTitle}>
                    Content Tracker
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="content-tracker"
                  id="trackercontent"
                >
                  <MenuList className={classes.navList}>
                    <ContentTrackerNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            {/* Admin */}
            {/* <PermittedContent modulePath={_mlAdmin}> */}
            {isSysAdmin() && (
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "mladmin"}
                onChange={handleChange("mladmin")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="mladmin1content"
                  id="mladmin"
                >
                  <FaUsersCog
                    title="Admin"
                    fontSize="small"
                    className={classes.newIcons}
                  />

                  <Typography className={classes.navigationTitle}>
                    Admin
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="mladmin"
                  id="mladmin1content"
                >
                  <MenuList className={classes.navList}>
                    <MlAdminNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            )}
            {/* </PermittedContent> */}

            {/* SM SYS Admin */}
            <PermittedContent modulePath={_smSysAdmin}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "smadmin"}
                onChange={handleChange("smadmin")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="mladmin1content"
                  id="smadmin"
                >
                  <FaUserCog
                    title="Admin"
                    fontSize="small"
                    className={classes.newIcons}
                  />
                  <Typography className={classes.navigationTitle}>
                    {t("navigation.smsysadmin")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="smadmin"
                  id="mladmin1content"
                >
                  <MenuList className={classes.navList}>
                    <SMSYSAdminNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            {/* PlayOut */}
            {/* <PermittedContent modulePath={_playouts}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "playout"}
                onChange={handleChange("playout")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="playoutcontent"
                  id="playout"
                >
                  <FaSatelliteDish
                    title="Playout"
                    fontSize="small"
                    className={classes.newIcons}
                  />

                  <Typography className={classes.navigationTitle}>
                    Playout
                  </Typography>
                </AccordionSummary>
                <AccordionDetails aria-labelledby="playout" id="playoutcontent">
                  <MenuList className={classes.navList}>
                    <PlayOutNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent> */}

            {/* Uploads */}
            <PermittedContent modulePath={_uploads}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "uploads"}
                onChange={handleChange("uploads")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="uploadscontent"
                  id="uploads"
                >
                  <FaUpload
                    title="Uploads"
                    fontSize="small"
                    className={classes.newIcons}
                  />

                  <Typography className={classes.navigationTitle}>
                    Uploads
                  </Typography>
                </AccordionSummary>
                <AccordionDetails aria-labelledby="uploads" id="uploadscontent">
                  <MenuList className={classes.navList}>
                    <TrackUploadNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            <PermittedContent modulePath={_smContentAdmin}>
              <Accordion
                className={classes.navigationAccordianTitle}
                expanded={expanded === "sm-content-admin"}
                onChange={handleChange("sm-content-admin")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="sm-content-admin-content"
                  id="sm-content-admin"
                >
                  <FaUser
                    title="SM Admin"
                    fontSize="small"
                    className={classes.newIcons}
                  />

                  <Typography className={classes.navigationTitle}>
                    SM Admin
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  aria-labelledby="sm-content-admin"
                  id="sm-content-admin-content"
                >
                  <MenuList className={classes.navList}>
                    <SMAdminNavigation classes={classes} />
                  </MenuList>
                </AccordionDetails>
              </Accordion>
            </PermittedContent>

            <MenuList className={classes.navList}>
              <PermittedContent modulePath={_smLog}>
                <SMLogNavigation classes={classes} />
              </PermittedContent>
              <PermittedContent modulePath={_smReports}>
                <SMReportsNavigation classes={classes} />
              </PermittedContent>
            </MenuList>

            {/* <PermittedContent modulePath={_uploads}>
            <MenuList
              className={classes.navList}
              aria-label={"Upload Tracks"}>
              <Switch aria-label={"Upload Tracks"}>
                <Route
                  path="/uploads/session/"
                  render={(props) => <UploadFiles {...props} />}
                />
              </Switch>
              <Switch aria-label={"Upload Tracks"}>
                <Route
                  path="/uploads/tracks/"
                  render={(props) => <UploadFiles {...props} />}
                />
              </Switch>
              <Switch aria-label={"Upload Tracks"}>
                <Route
                  path="/uploads/albums/"
                  render={(props) => <UploadFiles {...props} />}
                />
              </Switch>
            </MenuList>
          </PermittedContent> */}

            <Typography className={classes.version} variant="inherit" noWrap>
              {t("navigation.Version")} : {packageJson.version}
            </Typography>

            <div className="termsLink">
              <a
                className="externalLinks"
                title="Terms &amp; Conditions"
                href="https://sky.musicbox.orfium.com/assets/sky/Soundmouse%20Terms%20of%20Use.pdf"
                target="_blank"
              >
                <span className="customLinkText">Terms &amp; Conditions</span>
              </a>

              <a
                className="externalLinks"
                title="Privacy Policy"
                href="https://sky.musicbox.orfium.com/assets/sky/Soundmouse%20Privacy%20Policy.pdf"
                target="_blank"
              >
                <span className="customLinkText">Privacy Policy</span>
              </a>
              {/* <a
                className="externalLinks"
                title="Acceptable Use Policy"
                href="#"
               
              >
                <span className="customLinkText">Acceptable Use Policy</span>
              </a> */}
            </div>
          </Paper>
        )
      }
    </Translation>
  );
  // }
};

Navigation.propTypes = {};

const mapStateToProps = (state) => ({
  user: state.user,
  orgRuntime: state.orgRuntime,
  allNews: state.allNews,
});

export default connect(mapStateToProps, { toggleNav })(
  withStyles(styles)(withRouter(Navigation))
);
